import { render } from "./PalletTypes.vue?vue&type=template&id=4fece2a7"
import script from "./PalletTypes.vue?vue&type=script&lang=ts"
export * from "./PalletTypes.vue?vue&type=script&lang=ts"
script.render = render

export default script